import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42a2cd18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-map" }

import {
  computed,
  useAttrs,
  provide,
  getCurrentInstance,
  ref,
  markRaw,
} from 'vue'
import { EventEmitter } from 'events'


export default /*#__PURE__*/_defineComponent({
  __name: 'app-amap',
  props: {
  mapStyle: {
    type: String,
    default: 'amap://styles/grey',
  },
},
  setup(__props, { expose }) {

const props = __props



const instance = getCurrentInstance()
const emitter = new EventEmitter()

/**
 * el-amap 绑定属性
 * @link https://vue-amap.guyixi.cn/zh-cn/base/amap.html#%E9%9D%99%E6%80%81%E5%B1%9E%E6%80%A7
 */
const attrs = useAttrs()
const mapAttrs = computed(() => ({
  zoom: 14,
  center: [104.053758, 30.540089],
  mapStyle: props.mapStyle,
  ...attrs,
}))
const map = ref<any>()
const init = (m: any) => {
  map.value = markRaw(m)
  emitter.emit('init', m)
}
const flyTo = async (lng: number, lat: number, duration = 0.3) => {
  map.value?.panTo([lng, lat], duration * 1000)
}

const fitView = async (
  overlays:
    | [number, number]
    | Array<[number, number]>
    | Array<Array<[number, number]>>,
  options?: {
    /**
     * immediately代表是否需要动画过程
     */
    immediately?: boolean
    /**
     * avoid代表上下左右的像素避让宽度，默认值 [60,60,60,60]
     */
    avoid?: Array<number>
  },
) => {
  const temp = []

  if (!Array.isArray(overlays[0])) {
    const point = overlays
    // 点
    temp.push(
      new AMap.Marker({
        position: new AMap.LngLat(point[0], point[1]),
      }),
    )
  } else if (!Array.isArray(overlays[0][0])) {
    // 线
    for (let i = 0; i < overlays.length; i++) {
      const point = overlays[i]
      temp.push(
        new AMap.Marker({
          position: new AMap.LngLat(point[0], point[1]),
        }),
      )
    }
  } else {
    // 面
    for (let i = 0; i < overlays.length; i++) {
      const overlays2:Array<any> = overlays[i]
      for (let j = 0; j < overlays2.length; j++) {
        const point = overlays[i][j]
        temp.push(
          new AMap.Marker({
            position: new AMap.LngLat(point[0], point[1]),
          }),
        )
      }
    }
  }
  console.log({
    immediately: false,
    ...options,
  })
  map.value?.setFitView(temp, options?.immediately || false, options?.avoid)
}

provide('$map', instance)
provide('$map-emitter', emitter)
provide('$amap', map)
expose({
  flyTo,
  fitView,
})

return (_ctx: any,_cache: any) => {
  const _component_el_amap = _resolveComponent("el-amap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_amap, _mergeProps(_unref(mapAttrs), { onInit: init }), {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16)
  ]))
}
}

})